import { createAction, props } from '@ngrx/store';
import { MwLoadOptions } from 'app/models/load-options.model';
import { MwPayloadModel } from 'app/models/payload.model';
import { ProjectApiModel } from 'app/models/projects-api.model';

export const loadProjects = createAction(
  '[Projects] Load',
  props<{ loadOptions: MwLoadOptions }>()
);

export const loadProjectsSuccess = createAction(
  '[Projects] Load Successful',
  props<{ response: MwPayloadModel<ProjectApiModel[]> }>()
);

export const loadProjectsFailed = createAction(
  '[Projects] Load Failed',
  props<{ error: any }>()
);

export const createProject = createAction(
  '[Projects] Create',
  props<{ project: ProjectApiModel }>()
);

export const createProjectSuccess = createAction(
  '[Projects] Create Successful'
);

export const createProjectFailed = createAction(
  '[Projects] Create Failed',
  props<{ error: any }>()
);

export const updateProject = createAction(
  '[Projects] Update',
  props<{ project: ProjectApiModel }>()
);

export const updateProjectSuccess = createAction(
  '[Projects] Update Successful'
);

export const updateProjectFailed = createAction(
  '[Projects] Update Failed',
  props<{ error: any }>()
);

export const deleteProject = createAction(
  '[Projects] Delete',
  props<{ project: ProjectApiModel }>()
);

export const deleteProjectSuccess = createAction(
  '[Projects] Delete Successful'
);

export const deleteProjectFailed = createAction(
  '[Projects] Delete Failed',
  props<{ error: any }>()
);

export const deleteProjectsList = createAction(
  '[Projects] Delete List',
  props<{ projects: ProjectApiModel[] }>()
);

export const deleteProjectsListSuccess = createAction(
  '[Projects] Delete List Successful'
);

export const deleteProjectsListFailed = createAction(
  '[Projects] Delete List Failed',
  props<{ error: any }>()
);

export const resetProjects = createAction('[Projects] Reset');
